<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.92895 4.92889C6.80432 3.05351 9.34788 1.99994 12.0001 1.99994C14.6522 1.99994 17.1958 3.05351 19.0712 4.92889C20.9465 6.80426 22.0001 9.34782 22.0001 12C22.0001 14.6522 20.9465 17.1957 19.0712 19.0711C17.1958 20.9465 14.6522 22 12.0001 22C9.34788 22 6.80432 20.9465 4.92895 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34782 3.05357 6.80426 4.92895 4.92889ZM7.09461 5.68034L18.3197 16.9054C19.4031 15.5097 20.0001 13.7856 20.0001 12C20.0001 9.87825 19.1572 7.8434 17.6569 6.3431C16.1566 4.8428 14.1218 3.99994 12.0001 3.99994C10.2144 3.99994 8.49033 4.59691 7.09461 5.68034ZM16.9055 18.3196L5.6804 7.09455C4.59698 8.49027 4 10.2144 4 12C4 14.1217 4.84286 16.1566 6.34316 17.6569C7.84346 19.1572 9.87831 20 12.0001 20C13.7857 20 15.5098 19.4031 16.9055 18.3196Z"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: "IconBan",
  props: ["height", "width"],
}
</script>
